/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isonline1Inputs */

const en__field_isonline1 = /** @type {(inputs: _Field_Isonline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is online`)
};

/**
* | output |
* | --- |
* | "Is online" |
*
* @param {_Field_Isonline1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_isonline1 = /** @type {((inputs?: _Field_Isonline1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isonline1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_isonline1(inputs)
});
export { _field_isonline1 as "_field_isOnline" }